export type AuthTokens = {
    accessToken: string | null,
    idToken: string | null,
};

const AUTH0_PREFIX = 'auth0';
const AUTH0_USER_FRAGMENT = '@@user@@';

const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
    const parts = token.split('.');
    if (parts.length < 2) {
        return null;
    }
    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
        const json = atob(padded);
        return JSON.parse(json) as Record<string, unknown>;

    } catch {
        return null;
    }
};

const isTokenExpired = (token: string): boolean => {
    const payload = decodeJwtPayload(token);
    const exp = payload?.exp;
    if (typeof exp !== 'number') {
        return false;
    }
    const nowInSeconds = Math.floor(Date.now() / 1000);
    return exp <= nowInSeconds;
};

export const getCachedAuthTokens = (): AuthTokens => {
    let accessToken: string | null = null;
    let idToken: string | null = null;

    const possibleKeys = Object.keys(localStorage)
        .filter(key => key.includes(AUTH0_PREFIX));

    for (const key of possibleKeys) {
        const cached = localStorage.getItem(key);
        if (!cached) {
            continue;
        }
        let shouldRemove = false;
        try {
            const parsed: unknown = JSON.parse(cached);
            if (typeof parsed === 'object' && parsed !== null) {
                const dataObj = parsed as {id_token?: unknown, body?: {access_token?: unknown}};
                if (!idToken && key.includes(AUTH0_USER_FRAGMENT) && typeof dataObj.id_token === 'string') {
                    if (isTokenExpired(dataObj.id_token)) {
                        shouldRemove = true;
                    } else {
                        idToken = dataObj.id_token;
                    }
                }
                const body = dataObj.body;
                if (!accessToken && body?.access_token && typeof body.access_token === 'string') {
                    if (isTokenExpired(body.access_token)) {
                        shouldRemove = true;
                    } else {
                        accessToken = body.access_token;
                    }
                }
            }
        } catch {
            continue;
        }
        if (shouldRemove) {
            localStorage.removeItem(key);
        }
    }

    return {accessToken, idToken};
};
